/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import imgSVG from './assets/virtual-agent-landing-app-skeleton.tpl.svg';

const customStyles = css({
	margin: '0 auto',
	maxWidth: '960px',
});

export const VirtualAgentLandingSkeleton = (): JSX.Element => (
	<AppSkeletonImage src={imgSVG} css={customStyles} />
);
